const vueAppApiUrl =
    process.env.VUE_APP_API_URL || 'https://api.gethighered.global/api/v1/';

export default {
    baseURL: vueAppApiUrl,
    template: [
        'ORGPROFILE_TEMPLATE',
        data => ({
            id: data.organizationId,
            title: data.title,
            description: data.description,
            logo: data.logo,
            webAddress: data.webAddress,
            banner: data.banner,
            locations: data.localOrganizations,
            articles: data.articles,
            videos: data.videos,
        }),
    ],
    '/profile': {
        '/:id': {
            GET: {},
        },

        '/banner': {
            '/:id': {
                template: [
                    'ORGPROFILE_ORGANIZATION_TEMPLATE',
                    data => ({
                        id: data.organizationId,
                        banner: data.banner,
                    }),
                ],
                GET: {},
            },
        },
    },
    '/article': {
        template: [
            'article_template',
            data => ({
                id: data.id,
                title: data.title,
                createdAt: data.createdAt,
                updatedAt: data.updatedAt,
                ingress: data.ingress,
                body: data.body,
            }),
        ],
        '/:id': {
            GET: {},
        },
    },
};
